import { textColorFields } from '../_shared/textColor.js';
import { universalFields } from '../_shared/universal.js';
/**
 * anchor-nav — a slim in-page navigation bar (the PDP "Purchase · Details · Compare · Reviews" anatomy):
 * an optional title at the left + a row of links. `sticky` pins it to the viewport top while the page
 * scrolls. Targets are plain links — point one at a section anchor (`#<section-id>`, enabled on the
 * target via its `displaySectionId` switch) for smooth in-page jumps, or at any URL.
 */
export const anchorNavSchema = {
    type: 'anchor-nav',
    name: 'Anchor navigation',
    version: 1,
    templates: ['index', 'product', 'collection', 'page', 'thank-you'],
    fields: [
        {
            id: 'title',
            type: 'text',
            label: 'Title',
            group: 'General',
            default: '',
            info: 'Optional label at the start of the bar (e.g. the product name).',
            maxLength: 80,
        },
        {
            id: 'sticky',
            type: 'checkbox',
            label: 'Stick to the top while scrolling',
            group: 'General',
            default: true,
        },
        {
            id: 'linksAlignment',
            type: 'select',
            label: 'Links alignment',
            group: 'General',
            default: 'end',
            options: [
                { value: 'start', label: 'Start' },
                { value: 'center', label: 'Center' },
                { value: 'end', label: 'End' },
            ],
        },
        {
            id: 'smoothScroll',
            type: 'checkbox',
            label: 'Smooth-scroll to anchors',
            group: 'General',
            default: true,
        },
        // Text colors — the seller's own colour/gradient for this band's headings and body text.
        ...textColorFields(),
        ...universalFields,
    ],
    blocks: [
        {
            type: 'item',
            name: 'Link',
            max: 8,
            fields: [
                {
                    id: 'label',
                    type: 'text',
                    label: 'Label',
                    default: 'Lien',
                    maxLength: 40,
                },
                {
                    id: 'link',
                    type: 'link',
                    label: 'Target',
                    info: 'A section anchor (#section-id) or any URL.',
                },
            ],
        },
    ],
    maxBlocks: 8,
};
export const anchorNavPresets = [
    {
        name: 'Anchor navigation',
        settings: {
            colorScheme: 'light',
            paddingTop: 0,
            paddingBottom: 0,
            width: 'wide',
        },
        blocks: [
            { type: 'item', settings: { label: 'Acheter' } },
            { type: 'item', settings: { label: 'Détails' } },
            { type: 'item', settings: { label: 'Avis' } },
        ],
    },
];
/**
 * How this section presents itself in "Add section": label, group, icon.
 *
 * It lives beside the schema, NOT in `index.ts`, and that is the point. `index.ts` is the module that pulls
 * in `Component.tsx`, and the builder reads `meta` for all sixty-two sections to paint the picker while
 * rendering only the handful a page actually uses. Keeping `meta` here lets `registry.lazy.gen.ts` import it
 * without dragging every section's render code into the editor's entry chunk.
 */
export const anchorNavMeta = {
    label: 'Anchor navigation',
    group: 'Navigation',
    icon: 'link',
};
//# sourceMappingURL=schema.js.map